import React, { useState, useEffect } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import MainLayout from "../../components/layout/MainLayout";
import Breadcrumbs from "../../components/common/Breadcrumbs";
import Cros3FormUI from "./Cros3FormUI";
import {
  fetchCros3Form,
  updateCros3Form,
  clearCurrentCros3Form,
} from "../../store/slices/cros3FormSlice";

const EditCros3Form = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useParams();
  const { state } = useLocation();
  const { caseId, patientId } = state || {};

  const { currentCros3Form, isLoading, error } = useSelector(
    (state) => state.cros3Forms
  );

  const [formData, setFormData] = useState({
    patient_id: patientId || "",
    case_id: caseId || "",
    consumer_details: {},
    consumer_responses: {},
    staff_details: {},
    staff_responses: {},
    vip_details: {},
    vip_responses: {},
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (id) {
      dispatch(fetchCros3Form(id));
    }
    return () => {
      dispatch(clearCurrentCros3Form());
    };
  }, [dispatch, id]);

  useEffect(() => {
    if (currentCros3Form && currentCros3Form.id === parseInt(id)) {
      setFormData({
        patient_id: currentCros3Form.patient_id || "",
        case_id: currentCros3Form.case_id || "",
        consumer_details: currentCros3Form.consumer_details || {},
        consumer_responses: currentCros3Form.consumer_responses || {},
        staff_details: currentCros3Form.staff_details || {},
        staff_responses: currentCros3Form.staff_responses || {},
        vip_details: currentCros3Form.vip_details || {},
        vip_responses: currentCros3Form.vip_responses || {},
      });
    }
  }, [currentCros3Form, id]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await dispatch(updateCros3Form({ id, formData })).unwrap();

      Swal.fire({
        title: "Success!",
        text: "CROS-3 Questionnaire updated successfully.",
        icon: "success",
        timer: 2000,
        showConfirmButton: false,
      });

      // Stay on edit page
    } catch (err) {
      let errorMessage = "Failed to update CROS-3 form";
      if (typeof err === "string") {
        errorMessage = err;
      } else if (typeof err === "object" && err !== null) {
        errorMessage = Object.values(err).flat().join("\n");
      }
      Swal.fire({
        title: "Error",
        text: errorMessage,
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  return (
    <MainLayout>
      <div className="container-xxl flex-grow-1 container-p-y">
        <Breadcrumbs />
        <div className="card">
          <div className="card-header border-bottom">
            <h5 className="mb-0">Edit CROS-3 Questionnaire</h5>
          </div>
          <div className="card-body">
            {isLoading ? (
              <div className="d-flex justify-content-center py-5">
                <div className="spinner-border text-primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              </div>
            ) : error ? (
              <div className="alert alert-danger m-4">{error}</div>
            ) : (
              <form onSubmit={handleSubmit}>
                <Cros3FormUI
                  formData={formData}
                  setFormData={setFormData}
                  errors={errors}
                />
                <div className="row px-4 pb-4">
                  <div className="col-md-2 ms-auto">
                    <button type="submit" className="btn btn-primary w-100">
                      <i className="ri-save-3-line me-1"></i> Update
                    </button>
                  </div>
                </div>
              </form>
            )}
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default EditCros3Form;
